import React, { useState, useEffect, useRef } from 'react'
import Api from '../../../../_helpers/Api'
import Skeleton from 'react-loading-skeleton'
import { useHistory, useLocation } from 'react-router-dom'
import { trans } from '../../../../_providers/Translation'
import { useAuthDataContext } from '../../../../_providers/Auth'
import { TYPE } from '../../../../_constants/Reservation'
import moment from 'moment'
import { Avatar } from '@mui/material'
import closeIcon from '../../../../assets/img/icons/close.png'
import checkIcon from '../../../../assets/img/icons/check.png'

function LatestReservations({ statusFilter, onClearFilter, filters }) {

    const auth = useAuthDataContext()
    const history = useHistory()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    const [state, setState] = useState({
        loading: true,
        data: [],
    })
    const fetchDebounceRef = useRef(null)

    const loadLatestReservations = () => {
        setState(prev => ({ ...prev, loading: true }))

        const dateParams = `date_from=${filters?.date_from || ''}&date_to=${filters?.date_to || ''}`

        const endpoint = statusFilter
            ? `reservations/latest?status_filter=${encodeURIComponent(statusFilter.id)}&${dateParams}`
            : `reservations/latest?${dateParams}`

        Api.get(endpoint)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data
                }))
            }).finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    useEffect(() => {
        clearTimeout(fetchDebounceRef.current)
        fetchDebounceRef.current = setTimeout(() => {
            loadLatestReservations()
        }, 300)
        return () => clearTimeout(fetchDebounceRef.current)
    }, [statusFilter, filters])

    useEffect(() => {
        const handleReservationAccepted = (event) => {
            loadLatestReservations()
        }

        window.addEventListener('reservationAccepted', handleReservationAccepted)

        return () => {
            window.removeEventListener('reservationAccepted', handleReservationAccepted)
        }
    }, [statusFilter, filters])

    return (
        <>
            <div
                className='head'
                style={{
                    marginBottom: '15px'
                }}
            >
                <h3
                    style={{
                        marginBottom: 0,
                    }}
                >
                    {trans('random.lastReservations')}
                    {statusFilter && (
                        <span
                            style={{
                                paddingLeft: "8px"
                            }}
                        >
                            - {trans('random.filteredBy')} {statusFilter.name}
                        </span>
                    )}
                </h3>
            </div>
            {state.loading
                ?
                <Skeleton height={55} count={3} />
                :
                state.data.length === 0
                    ?
                    <div
                        className="alert warning"
                        style={{
                            marginBottom: 0,
                            width: '100%',
                        }}
                    >
                        {trans("messages.noDataFound")}
                    </div>
                    :
                    <div className="table-scroller">
                        <table className="latest-reservations-table">
                            <thead className="table-header">
                                <tr>
                                    <th>{trans('tables.visitDate')}</th>
                                    <th>{trans('tables.setTo')}</th>
                                    <th>{trans('tables.clientCompany')}</th>
                                    <th>{trans('tables.address')}</th>
                                    <th className="right">{trans('tables.paidPrice')}</th>
                                    <th className="right">{trans('tables.finalPrice')}</th>
                                    <th>{trans('tables.status')}</th>
                                    <th className="center">{trans('tables.online')}</th>
                                    <th>{trans('tables.activeOrCompleted')}</th>
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {state.data.map((row, index) =>
                                    <tr
                                        key={row.id}
                                    >

                                        <td>
                                            {`${row.visit_date
                                                ? `${row.visit_date_dmy}`
                                                : '-'
                                                } ${row.visitperiod
                                                    ? `${row.visitperiod.period}`
                                                    : '-'
                                                }`}
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>

                                                {row.performer?.avatar ?
                                                    <img src={row.performer.avatar} alt=""
                                                        style={{ width: 25, height: 25, borderRadius: 50, objectFit: 'cover', marginRight: 5 }}
                                                    />
                                                    : <></>
                                                }
                                                {row.performer
                                                    ?
                                                    row.performer_type === 'App\\Employee' || row.performer_type === 'App\\Models\\Employee'
                                                        ? `${row.performer.name} ${row.performer.lastname}`
                                                        : `${row.performer.name}`
                                                    :
                                                    '-'
                                                }
                                            </div>

                                        </td>
                                        <td>
                                            {row.customer ? `${row.customer.name} ${row.customer.lastname}` : '-'} {row.contractor && `(${row.contractor.name})`}
                                        </td>
                                        <td>
                                            {row.res_type_id === TYPE.ON_SITE_REPAIR ? trans('labels.onSiteRepair') : row.full_address}
                                        </td>
                                        <td className="right">
                                            {(row.paid_price || 0).toFixed(2)} {row.currency?.name || 'EUR'}
                                        </td>
                                        <td className="right">
                                            {(row.total_price || 0).toFixed(2)} {row.currency?.name || 'EUR'}
                                        </td>
                                        <td>
                                            {/* {row.status && row.status.translation.name} */}
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <img src={row?.master?.finalstatus ? row?.finalstatus?.icon?.url : row.initialstatus?.icon?.url} alt="" style={{ marginRight: 8, marginLeft: 0, width: 16, height: 16 }} />
                                                <span
                                                    style={{
                                                        // backgroundColor: row.initialstatus?.color || "#20587bff",
                                                        // color: row.text_color || "#fff",
                                                        // padding: "7px 12px",
                                                        fontSize: "inherit",
                                                        borderRadius: 12,
                                                    }}
                                                >
                                                    {row?.master?.share_status
                                                        ? trans('statuses.' + row?.master?.share_status)
                                                        : row.finalstatus && row.finalstatus.translation && row.finalstatus.translation.name
                                                            ? row.finalstatus.translation.name
                                                            : row.initialstatus && row.initialstatus.translation && row.initialstatus.translation.name}
                                                </span>
                                            </div>
                                        </td>

                                        <td className="center">
                                            {row.has_online
                                                ?
                                                <img src={checkIcon} height="12" />
                                                :
                                                <img src={closeIcon} height="12" />
                                            }
                                        </td>

                                        {/* <td>
                                                    {getReservationType(row)}
                                                </td> */}

                                        <td>
                                            <span
                                                style={{
                                                    color: row.activity_status === 'completed' ? '#3a52b6' : '#28a745',
                                                    fontSize: 'inherit',
                                                    borderRadius: 12,
                                                }}
                                            >
                                                {row.activity_status === 'completed'
                                                    ? trans('labels.reservation-status.completed')
                                                    : trans('labels.reservation-status.active')}
                                            </span>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
            }
        </>
    )
}

export default LatestReservations